<script>
  import Accordion from "$lib/components/Accordion.svelte";
  import Bleed from "$lib/components/Bleed.svelte";
  export let highTierContributors;
</script>

<Bleed fullWidth>
  <div class="w-full pt-32 pb-48 md:py-72 md:w-3/5 lg:w-806 m-auto">
    {#each highTierContributors as tier}
      <Accordion label={tier.category} isOpen={false}>
        <div class="py-4">
          {#each tier.contributors as contributor}
            <p>{contributor.name}</p>
          {/each}
        </div>
      </Accordion>
    {/each}
  </div>
</Bleed>
